<template>
    <div name="download" class="download">
        <img class="image" src="../assets/download_bg.png" />
        <span class="text1">지금 설치하고<br/>바로 사용하세요</span>
        <div class="down-button" @click="appDown">
            <img class="download-logo" src="../assets/download.png"/>
            앱 다운로드
        </div>
    </div>
</template>

<script>
export default {
    name: 'download',
    data: function()
    {
        return {
            abx_tid: null
        }
    },  
    mounted: function()
    {

        $(window).scroll(function () {
            var height = $(document).scrollTop();
            // console.log(height)
            if(height > 223)
            {
                $('#float-button').css('display', `flex`);
            }
        })

        function getAbxTidParameter() {
            var landingPageUrl = window.location.search.substring(1),
                referrerDatas = landingPageUrl.split('&'),
                referrerParamName,
                i;
        
            for (i = 0; i < referrerDatas.length; i++) {
                referrerParamName = referrerDatas[i].split('=');
        
                if (referrerParamName[0] === "abx_tid") {
                    return referrerParamName[1] === undefined ? true : referrerParamName[1];
                }
            }
        };
        this.abx_tid = getAbxTidParameter();
    },
    methods: {
        appDown: function()
        {
            if (!wcs_add) var wcs_add={};
                window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
                if (!_nasa) var _nasa={};
                if(window.wcs){
                    wcs.inflow();
                    wcs_do();
                }
            if(window.wcs){
                if(!wcs_add) var wcs_add = {};
                window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
                var _conv = {};
                    _conv.type = 'lead';    	
                wcs.trans(_conv);
            }


            // 앱의 스키마 URL
            var appSchemeURL = 'soldoc://home';
            // 안드로이드와 iOS 마켓 URL
            var androidMarketURL = 'https://play.google.com/store/apps/details?id=com.soldocapp';
            var iosMarketURL = 'https://apps.apple.com/kr/app/soldoc-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511';

            if(this.abx_tid !== undefined)
            {
                appSchemeURL = 'soldoc://home?abx_tid=' + this.abx_tid;
                androidMarketURL = 'https://play.google.com/store/apps/details?id=com.soldocapp&referrer=abx_tid%3D' + this.abx_tid;  // Google Play 스토어 링크
                iosMarketURL = 'https://apps.apple.com/kr/app/%EC%86%94%EB%8B%A5-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511?&referrer=abx_tid%3D' + this.abx_tid;  //appstore 스토어 링크
            }
            
            
            // 리다이렉트를 체크할 시간 간격
            var timeoutMs = 2000;

            // 앱 실행 시도
            window.location.href = appSchemeURL;

            // 2초 후에 페이지 가시성 체크
            setTimeout(function() {
                if (document.visibilityState === 'visible') {
                    // 사용자의 기기에 따라 적절한 마켓으로 리다이렉트
                    if (navigator.userAgent.match(/Android/i)) {
                        window.location.href = androidMarketURL;
                    } else if (navigator.userAgent.match(/iPhone|iPad/i)) {
                        window.location.href = iosMarketURL;
                    }
                }
            }, timeoutMs);   

            // var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            // var scheme, fallbackLink;
            // var timeout = 1000;  // 1000ms = 1초 후 폴백 실행
            // // iOS 디바이스 판별
            // if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                
            //     if(this.abx_tid !== undefined)
            //     {
            //         scheme = 'soldoc://home?abx_tid=' + this.abx_tid;  // iOS용 URL 스키마
            //         fallbackLink = 'https://apps.apple.com/kr/app/%EC%86%94%EB%8B%A5-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511?&referrer=abx_tid%3D' + this.abx_tid;  // Google Play 스토어 링크
            //     }
            //     else
            //     {
            //         scheme = 'soldoc://home';
            //         fallbackLink = 'https://apps.apple.com/kr/app/%EC%86%94%EB%8B%A5-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511';
            //     }
            // }
            // // Android 디바이스 판별
            // else if (/android/i.test(userAgent)) {
            //     if(this.abx_tid !== undefined)
            //     {
            //         scheme = 'soldoc://home?abx_tid=' + this.abx_tid;
            //         fallbackLink = 'https://play.google.com/store/apps/details?id=com.soldocapp&referrer=abx_tid%3D' + this.abx_tid;  // Google Play 스토어 링크
            //     }
            //     else
            //     {
            //         scheme = 'soldoc://home';
            //         fallbackLink = 'https://play.google.com/store/apps/details?id=com.soldocapp'
            //     }
            // } else {
            //     // alert('Unsupported device');
            //     window.location = "https://soldoc.co.kr";
            //     return;
            // }

            // var clickedAt = +new Date();  // 클릭 시간을 기록
            // setTimeout(function() {
            //     var now = +new Date();
            //     if (now - clickedAt < timeout + 1000) {  // 사용자가 빠르게 돌아왔다면 앱 스토어로 이동
            //         window.location = fallbackLink;
            //     }
            // }, timeout);

            // window.location = scheme;  // 딥링크를 통해 앱 시도 열기
        }
    }
}
</script>

<style scoped>
    .download {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    
    }
    .image {
        width: 100%;
        z-index: 0;
    }
    .text1{
        color: #FFF;
        text-align: center;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; /* 126.667% */
        z-index: 1;
        top: 70px;
        position: absolute;

    }
    .down-button {
        display: flex;
        padding: 8px 22px 8px 20px;
        justify-content: center;
        align-items: center;
        gap: 2px;
        border-radius: 22px;
        background: #008DEF;
        color: #FFF;
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px; /* 185.714% */
        width: 128px;
        cursor: pointer;
        z-index: 1;
        position: absolute;
        top: 174px;
    }

    .download-logo {
        width: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Download.vue